import axios, {AxiosResponse} from 'axios'

const API_URL_NEW = process.env.REACT_APP_API_URL_NEW
const GET_PRODUCTS_GROUP_URL = `${API_URL_NEW}/product/group/list/all`
const LOCATION_LIST_URL = `${API_URL_NEW}/location/allLocations`
const OFFER_LIST_FOR_SELLER = `${API_URL_NEW}/offer/offers/offerListForSeller`
const CHECK_FINAL_PRICE_URL = `${API_URL_NEW}/inquiry/qtyBasedInquiryForOfferWithPrice`
const GET_GRADES_URL = `${API_URL_NEW}/grade-group`
const GET_PRODUCTS_URL = `${API_URL_NEW}/product`

export interface OfferListForSellerPayload {
  grade_group_id?: string
  product_group_id?: string
  product_id?: string
  buyer_destination_location_id: string
  offer_status: string // 'Active' | 'Inactive' | 'all' (or '1' | '0' | 'all')
  quantity?: number | string // required only when action === 'excel'
  radius_km: number | string
  action: 'excel' | 'push_notification'
}

// Builds a query string, only including keys whose value is non-empty/defined.
// This is what ensures `search=` (and any other optional param) is left out
// entirely when the value is blank, instead of always sending `search=`.
const buildQueryParams = (params: Record<string, any>): string => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value))
    }
  })
  return searchParams.toString()
}

const getGradeGroup = (search: any): Promise<any> => {
  const query = buildQueryParams({page: 1, perPage: 100, search})
  return axios.get(`${GET_GRADES_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
}

// gradeGroupId (optional): when provided, only product groups belonging to
// that grade group are returned — powers the Grade Group -> Product Group cascade.
const getProductGroup = (search: any, gradeGroupId?: any): Promise<any> => {
  const query = buildQueryParams({
    page: 1,
    perPage: 1000,
    search,
    grade_group_id: gradeGroupId,
  })
  return axios.get(`${GET_PRODUCTS_GROUP_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
}

// productGroupId (optional): when provided, only products belonging to that
// product group are returned — powers the Product Group -> Product cascade.
const getProducts = (search: any, productGroupId?: any): Promise<any> => {
  const query = buildQueryParams({
    page: 1,
    perPage: 5000,
    search,
    product_group_id: productGroupId,
  })
  return axios.get(`${GET_PRODUCTS_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
}

const locationListApi = (search: any): Promise<any> => {
  const query = buildQueryParams({search})
  return axios.get(`${LOCATION_LIST_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
}

const offerListForSeller = (payload: OfferListForSellerPayload): Promise<any> => {
  const isExcel = payload.action === 'excel'

  return axios
    .post(`${OFFER_LIST_FOR_SELLER}`, payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
      // excel comes back as a CSV stream, push_notification comes back as JSON
      responseType: isExcel ? 'blob' : 'json',
    })
    .then((d: AxiosResponse<any>) => d) // return full response so caller can read headers for blob handling
}

const checkFinalOfferPriceApi = (data: any): Promise<any> => {
  return axios.post(CHECK_FINAL_PRICE_URL, data).then((d: AxiosResponse<any>) => d.data)
}

export {
  getGradeGroup,
  getProductGroup,
  getProducts,
  locationListApi,
  offerListForSeller,
  checkFinalOfferPriceApi,
}
